import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  output,
} from '@angular/core';
import {
  CardComponent,
  CardContentComponent,
  IconComponent,
} from '@gains-com/ui-angular';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { decimal } from '@gains-com/shared';
import { PurchaseDialogHeaderComponent } from '../purchase-dialog-header/purchase-dialog-header.component.js';
import { BlockchainUrlPipe } from '../../../../pipes/blockchain-url.pipe.js';
import { PaymentStatusIndicatorComponent } from '../../payment-status-indicator/payment-status-indicator.component.js';
import { PurchaseAndPaymentUpdateRTM } from '@gains-com/realtime';
import { CurrenciesViewService } from '../../../../core/view-states/currencies-view.service.js';
import { toSignal } from '@angular/core/rxjs-interop';
import { DecimalPipe } from '../../../../pipes/decimal.pipe.js';

@Component({
  selector: 'app-crypto-confirm-purchase',
  templateUrl: './crypto-confirm-purchase.component.html',
  styleUrls: ['../styles.scss', './crypto-confirm-purchase.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CardComponent,
    CardContentComponent,
    PurchaseDialogHeaderComponent,
    DecimalPipe,
    CurrencyPipe,
    BlockchainUrlPipe,
    IconComponent,
    PaymentStatusIndicatorComponent,
    DatePipe,
  ],
})
export class CryptoConfirmPurchaseComponent {
  currenciesView = inject(CurrenciesViewService);
  currencies = toSignal(this.currenciesView.currencies$);

  step = input<number>();
  purchase = input.required<PurchaseAndPaymentUpdateRTM>();

  close = output<'contact-support' | void>();

  actualPaidUsd = computed(() => {
    const p = this.purchase();
    if (!p?.amount || !p.amount_usd_conversion_rate) return null;
    return decimal(p.amount).mul(p.amount_usd_conversion_rate).toNumber();
  });
  currentCurrency = computed(() =>
    this.currencies()?.find(
      (c) => c.currency_id === this.purchase()?.currency_id
    )
  );
}
